import { render, staticRenderFns } from "./PeriodPriceNoteDialog.vue?vue&type=template&id=21375c6d"
import script from "./PeriodPriceNoteDialog.vue?vue&type=script&lang=js"
export * from "./PeriodPriceNoteDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports